import script from "./LlPracticeAreaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LlPracticeAreaSelect.vue?vue&type=script&setup=true&lang=js"

import "./LlPracticeAreaSelect.vue?vue&type=style&index=0&id=780fadcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780fadcb"]])

export default __exports__